import { BasicReturn, IBasicReturn } from '@interfaces/IBasicReturn';
import appAxiosInstance from '../../../Utils/appAxiosInstance';

const onCheckingIsOwner = async (): Promise<IBasicReturn<boolean>> => {
  let basicReturn: IBasicReturn<boolean> = new BasicReturn(true);

  await appAxiosInstance()
    .get<IBasicReturn<boolean>>('Identity/IsOwner')
    .then((response): IBasicReturn<boolean> => {
      const { data } = response;

      basicReturn = data;

      return basicReturn;
    })
    .catch((): IBasicReturn => {
      basicReturn = new BasicReturn(false);

      return basicReturn;
    });

  return basicReturn;
};

export default onCheckingIsOwner;
